var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGooglePlay = function SvgGooglePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 60,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#google-play_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 40,
    x: 10,
    y: 6,
    fill: "#fff",
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play_svg__b)",
    d: "M18.125 16.03c-.241.245-.38.628-.38 1.124v17.692c0 .496.139.88.38 1.125l.06.054 10.167-9.91v-.234l-10.168-9.91-.06.058Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play_svg__c)",
    d: "m31.737 29.42-3.385-3.305v-.234l3.39-3.305.075.043 4.015 2.227c1.145.632 1.145 1.672 0 2.308l-4.015 2.223-.08.043Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play_svg__d)",
    d: "m31.818 29.378-3.465-3.38-10.228 9.973c.38.39 1.001.438 1.707.048l11.986-6.641Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play_svg__e)",
    d: "m31.818 22.62-11.986-6.642c-.706-.386-1.326-.338-1.707.051L28.353 26l3.465-3.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M49.668 17.883c0 .668-.205 1.203-.61 1.602-.464.473-1.07.71-1.81.71a2.522 2.522 0 0 1-1.811-.718c-.497-.484-.746-1.078-.746-1.79 0-.71.249-1.304.746-1.784a2.51 2.51 0 0 1 1.81-.723c.353 0 .69.07 1.01.203a2 2 0 0 1 .77.535l-.429.422c-.33-.38-.777-.566-1.35-.566-.518 0-.966.176-1.346.53-.377.357-.566.818-.566 1.384s.19 1.03.566 1.387c.38.35.828.53 1.345.53.549 0 1.01-.18 1.375-.534.24-.235.376-.56.412-.973h-1.787v-.578h2.384c.029.125.037.246.037.363Zm3.781-2.004H51.21v1.52h2.018v.578H51.21v1.52h2.239v.589h-2.873V15.29h2.873v.589Zm2.669 4.207h-.633v-4.207H54.11v-.589h3.382v.589h-1.375v4.207Zm3.822 0V15.29h.632v4.796h-.633Zm3.438 0h-.628v-4.207h-1.38v-.589h3.386v.589h-1.379v4.207Zm7.78-.617c-.486.485-1.087.727-1.803.727-.722 0-1.323-.242-1.808-.727-.484-.484-.725-1.078-.725-1.781 0-.703.241-1.297.725-1.781.486-.485 1.087-.727 1.808-.727.712 0 1.313.242 1.799.73.488.489.729 1.079.729 1.778 0 .703-.241 1.297-.725 1.78Zm-3.142-.402c.365.359.81.539 1.339.539.525 0 .973-.18 1.334-.54.364-.358.549-.82.549-1.378 0-.56-.185-1.02-.55-1.38a1.824 1.824 0 0 0-1.333-.538c-.53 0-.974.18-1.339.539-.364.359-.549.82-.549 1.379s.185 1.02.55 1.379Zm4.756 1.019V15.29h.769l2.392 3.73h.027l-.027-.922V15.29h.632v4.796h-.66L73.4 16.172h-.028l.028.926v2.988h-.629Zm-5.849 6.874c-1.927 0-3.501 1.43-3.501 3.404 0 1.957 1.574 3.402 3.501 3.402 1.931 0 3.506-1.445 3.506-3.402 0-1.973-1.575-3.403-3.506-3.403Zm0 5.466c-1.057 0-1.967-.851-1.967-2.062 0-1.227.91-2.063 1.967-2.063 1.058 0 1.971.836 1.971 2.063 0 1.21-.913 2.062-1.97 2.062Zm-7.64-5.465c-1.931 0-3.501 1.43-3.501 3.403 0 1.957 1.57 3.402 3.501 3.402 1.93 0 3.502-1.445 3.502-3.402 0-1.973-1.572-3.403-3.502-3.403Zm0 5.465c-1.058 0-1.971-.851-1.971-2.062 0-1.227.913-2.063 1.971-2.063s1.967.836 1.967 2.063c0 1.21-.91 2.062-1.967 2.062Zm-9.091-4.422v1.446h3.541c-.103.808-.38 1.402-.805 1.816-.517.5-1.322 1.055-2.736 1.055-2.18 0-3.886-1.715-3.886-3.84s1.706-3.84 3.886-3.84c1.178 0 2.036.449 2.669 1.03l1.045-1.018c-.885-.824-2.063-1.457-3.714-1.457-2.989 0-5.5 2.37-5.5 5.285 0 2.914 2.511 5.285 5.5 5.285 1.615 0 2.829-.516 3.782-1.484.978-.953 1.283-2.293 1.283-3.375 0-.336-.03-.645-.08-.903h-4.985Zm37.175 1.12c-.288-.76-1.177-2.163-2.988-2.163-1.795 0-3.29 1.379-3.29 3.403 0 1.906 1.48 3.402 3.462 3.402a3.48 3.48 0 0 0 2.909-1.508l-1.19-.773c-.397.566-.938.94-1.72.94-.775 0-1.332-.346-1.69-1.03l4.668-1.883-.16-.387Zm-4.759 1.134a1.888 1.888 0 0 1 1.823-1.984c.61 0 1.126.297 1.298.722l-3.12 1.262Zm-3.794 3.3h1.535v-10h-1.535v10Zm-2.512-5.84h-.052c-.344-.397-1.002-.757-1.835-.757-1.747 0-3.345 1.496-3.345 3.414 0 1.907 1.598 3.39 3.346 3.39.832 0 1.49-.362 1.834-.772h.052v.488c0 1.3-.713 2-1.863 2-.937 0-1.519-.66-1.759-1.215l-1.334.543a3.328 3.328 0 0 0 3.093 2.012c1.8 0 3.317-1.032 3.317-3.543v-6.11h-1.454v.55Zm-1.755 4.708c-1.058 0-1.943-.863-1.943-2.051 0-1.2.885-2.074 1.943-2.074 1.042 0 1.863.875 1.863 2.074 0 1.188-.821 2.05-1.863 2.05Zm20.004-8.867h-3.67v10h1.53v-3.79h2.14c1.7 0 3.366-1.198 3.366-3.105 0-1.906-1.67-3.105-3.366-3.105Zm.04 4.82h-2.18v-3.43h2.18c1.142 0 1.795.926 1.795 1.715 0 .774-.653 1.715-1.795 1.715Zm9.459-1.437c-1.105 0-2.255.476-2.728 1.53l1.358.556c.292-.555.83-.735 1.398-.735.794 0 1.599.465 1.611 1.286v.105c-.277-.156-.869-.387-1.599-.387-1.462 0-2.952.785-2.952 2.25 0 1.34 1.197 2.203 2.544 2.203 1.03 0 1.598-.453 1.955-.98h.052v.773h1.478v-3.836c0-1.773-1.358-2.765-3.117-2.765Zm-.184 5.48c-.501 0-1.198-.242-1.198-.847 0-.774.87-1.071 1.622-1.071.674 0 .99.145 1.399.336-.12.926-.937 1.582-1.823 1.582Zm8.686-5.261-1.759 4.335h-.052l-1.819-4.335h-1.65l2.732 6.058-1.559 3.37h1.599l4.21-9.428h-1.702Zm-13.794 6.398h1.534v-10h-1.534v10Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__b",
    x1: 27.45,
    x2: 14.028,
    y1: 35.031,
    y2: 21.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__c",
    x1: 37.323,
    x2: 17.47,
    y1: 25.997,
    y2: 25.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__d",
    x1: 29.934,
    x2: 11.733,
    y1: 24.162,
    y2: 5.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play_svg__e",
    x1: 15.55,
    x2: 23.678,
    y1: 41.858,
    y2: 33.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "google-play_svg__a",
    width: 132,
    height: 60,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13692_116107"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_13692_116107",
    result: "shape"
  })))));
};
export default SvgGooglePlay;